<template>
  <div class="payroll">
    <div class="payroll-header">
      <DatePicker
        class="date-picker"
        type="year"
        :value="year"
        :editable="false"
        :clearable="false"
        @on-change="onChange"
      ></DatePicker>
      <div class="payroll-header-total">
        {{ $t('payroll.list.total') }}:
        <span :class="['amount']">
          {{
            !isEye
              ? '****'
              : payslips.totalActualSalary
              ? payslips.totalActualSalary
              : '--'
          }}
        </span>
        <div class="link-btn" @click="onShowEye()">
          <Icon
            :size="20"
            color="#1F2329"
            :type="isEye ? 'ios-eye-outline' : 'ios-eye-off-outline'"
          />
        </div>
      </div>
    </div>
    <div class="payroll-content">
      <Table
        :max-height="485"
        ref="oaTable"
        :loading="loading"
        :columns="columns"
        @on-row-click="onRowClick"
        :data="payslips.payslips"
      />
    </div>
    <!-- 二级密码验证 -->
    <SecondaryPasswordModal
      ref="secondaryPasswordRef"
      @complete="onSuccessVerify"
    />
    <!-- 工资单详情-->
    <PayrollDetailModal @update="initPayslips" ref="payrollDetailRef" />
  </div>
</template>
<script>
import PayrollDetailModal from './components/DetailModal.vue';
import SecondaryPasswordModal from './components/SecondaryPasswordModal.vue';

export default {
  name: 'list',
  components: { PayrollDetailModal, SecondaryPasswordModal },
  data() {
    return {
      year: this.$moment().format('YYYY'),
      loading: false,
      isEye: false,
      columns: [
        {
          title: this.$t('payroll.list.date'),
          render: (_h, { row }) => {
            return (
              <div>
                {row.year}-{row.month}
              </div>
            );
          }
        },
        {
          title: this.$t('payroll.list.name'),
          key: 'name'
        },
        {
          title: this.$t('payroll.list.cycle'),
          render: (_h, { row }) => {
            return (
              <div>
                {row.startedDate} ~ {row.endedDate}
              </div>
            );
          }
        },
        {
          title: this.$t('payroll.list.paymentDate'),
          key: 'paymentDate'
        },
        {
          title: this.$t('payroll.list.status'),
          render: (_h, { row }) => {
            return (
              <span class={row.confirmedAt ? 'confirmed' : 'notConfirmed'}>
                {this.$t(
                  `payroll.list.${
                    row.confirmedAt ? 'confirmed' : 'notConfirmed'
                  }`
                )}
              </span>
            );
          }
        }
      ],
      payslips: { payslips: [] },
      secondaryConfig: {
        enableFlag: false,
        passwordFlag: false
      }
    };
  },
  mounted() {
    this.initPayrollSecondaryPassword();
    this.initPayslips();
  },
  methods: {
    async initPayrollSecondaryPassword() {
      try {
        const { data } = await this.$http(
          'get',
          'mobile/payroll_secondary_password',
          {},
          true
        );
        this.secondaryConfig = data;
      } finally {
      }
    },

    onShowPasswordValidate(action) {
      const secondaryPassword = sessionStorage.getItem('secondaryPassword');
      if (secondaryPassword) return false;
      if (!this.secondaryConfig.enableFlag) return false;
      if (!this.secondaryConfig.passwordFlag) {
        this.$Message.error(this.$t('secondaryPassword.noSettingPassword'));
      } else {
        this.$refs.secondaryPasswordRef.onOpen(action);
      }
      return true;
    },

    onSuccessVerify(action) {
      if (action === 'showEye') {
        this.isEye = true;
        localStorage.setItem('eye', this.isEye ? '1' : '0');
      } else {
        this.$refs.payrollDetailRef.onOpen(action.id);
      }
    },

    onChange(year) {
      this.year = year;
      this.initPayslips();
    },

    onShowEye() {
      if (this.isEye) {
        this.isEye = false;
        localStorage.setItem('eye', this.isEye ? '1' : '0');
        return;
      }
      const validate = this.onShowPasswordValidate('showEye');
      if (!this.isEye && validate) return;
      this.isEye = true;
      localStorage.setItem('eye', this.isEye ? '1' : '0');
    },

    async initPayslips() {
      try {
        this.loading = true;
        const { data } = await this.$http(
          'get',
          'mobile/payroll_confirmations',
          { year: this.year },
          true
        );
        if (data.content) {
          this.payslips.payslips = data.content;
        } else {
          this.payslips = data;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },

    onRowClick(row) {
      const validate = this.onShowPasswordValidate(row);
      if (validate) return;
      this.$refs.payrollDetailRef.onOpen(row.id);
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-table {
  &-row {
    cursor: pointer;
  }
}

.payroll {
  padding: 24px 0;

  &-header {
    display: flex;
    gap: 26px;
    margin-bottom: 24px;
    align-items: center;

    .date-picker {
      width: 170px;
    }

    &-total {
      display: flex;
      font-size: 14px;
      color: #1f2329;
      font-weight: 400;
      align-items: center;

      .amount {
        margin: 0 8px;
        font-weight: bold;
        font-size: 24px;
        color: #f54b45;
      }
    }
  }
}

.link {
  &-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-btn:hover {
    cursor: pointer;
    background-color: #f5f7fa;
  }
}

.confirmed {
  color: #00cb80;
}

.notConfirmed {
  color: #ffae33;
}
</style>
